'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.getVersionString = getVersionString;
var VERSION = '2.4.0';

function getVersionString() {
    return VERSION;
}
//# sourceMappingURL=Version.js.map



//////////////////
// WEBPACK FOOTER
// ./~/dashjs/build/es5/src/core/Version.js
// module id = 545
// module chunks = 0 1 2 3